// @charset "utf-8";
import axios from 'axios'
// import qs from 'qs'

axios.defaults.baseURL = '/developer/'
// 拦截器 请求
axios.interceptors.request.use(function (config) {
    // 用于服务端判断是否是ajax
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    return config
}, function (err) {
    return Promise.reject(err)
})

// 拦截器 响应
axios.interceptors.response.use(function (res) {
    // 维护中
    if (res.data.status_code === 5001 && res.data.status_msg === 'maintenence') {
        window.location.href = '/maintenance.html'
        throw new Error('平台维护中')
    }
    // 没权限
    if (res.data.status_code === -401 && res.data.status_msg === 'noauth') {
        // ThsLogin.showLoginBox(window.location.origin + '/developer/pop-login.html')
        window.LoginInstance.show()
    }
    return res
}, function (err) {
    return Promise.reject(err)
})



// WEBPACK FOOTER //
// ./src/lib/axiosConfig.js